// extracted by mini-css-extract-plugin
module.exports = {"container":"Accordian_container__roSSE","title":"Accordian_title__WIvRU","icon_container":"Accordian_icon_container__q5PQC","content":"Accordian_content__kBZnd"};